<template>
  <!-- O nome em fórmulas como DICA do identificador, e não um campo somente leitura ao lado: são duas
       grafias da MESMA identidade — em URL e no banco vale o identificador em kebab; numa fórmula, o
       hífen é o sinal de menos, e vale o camelCase (ver o `formulaName`). Quem escolhe é o
       identificador; a dica existe para o designer conhecer, desde que a propriedade nasce, o nome que
       vai escrever numa fórmula. -->
  <ontos-computed-input
      :label="$tt('alias-url')"
      class="ontos-code" :class="{'required unique': !fixed}"
      :value="alias"
      :manual="manual" @input:manual="$emit('update:manual', $event)"
      :source="source"
      :readonly="fixed"
      :compute="$utils.aliasSuggestion"
      :computeOnInput="$utils.incompleteAliasSuggestion"
      :error-messages="errorMessage"
      :hint="formula ? $tt('formula-name-hint', {name: formula}) : ''"
      hide-details="auto"
      @input="$emit('input', $event)"
      @blur="$emit('blur')"
  />
</template>

<script lang="ts">
import {Component, Prop, Vue, toNative} from 'vue-facing-decorator'
import ComputedInput from '@/components/shared/ComputedInput.vue'
import {formulaName} from '@/utils/utils'

/**
 * O identificador de uma propriedade, com o nome dela em fórmulas na dica.
 *
 * Os formulários de propriedade tinham o mesmo bloco de alias escrito cada um, e o nome de fórmula
 * seria a cópia de uma segunda coisa. Todos leem daqui.
 */
@Component({
  name: 'ontos-alias-fields',
  emits: ['input', 'blur', 'update:manual'],
  components: {'ontos-computed-input': ComputedInput}
})
class AliasFields extends Vue {
  @Prop({type: String, default: ''}) readonly alias!: string
  /** De onde a sugestão de alias sai — o nome. */
  @Prop({default: ''}) readonly source!: any
  @Prop({type: Boolean, default: false}) readonly manual!: boolean
  /** Alias que já existe não muda: é a chave gravada nos itens. */
  @Prop({type: Boolean, default: false}) readonly fixed!: boolean
  @Prop({type: String, default: ''}) readonly errorMessage!: string

  get formula(): string {
    return this.alias ? formulaName(this.alias) : ''
  }
}

export default toNative(AliasFields)
</script>
